import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { ModalHeader } from '../../Elements/modal/CustomModal/index.styled'
import { colorTheme } from '../../../style/theme/colorTheme'

export const ProcessingModalWrapper = styled.div`
	font-size: 1rem;
	min-height: 100px;
	display: grid;
	grid-template-columns: 1fr 11.25em;
	grid-gap: 3.125em;

	@media screen and (max-width: ${theme.point820}) {
		margin-bottom: 2.85em;
	}

	@media screen and (max-width: ${theme.point720}) {
		gap: 0.63em;
		grid-template-columns: auto;
		margin-bottom: 4.68em;
	}
`
ProcessingModalWrapper.displayName = 'ProcessingModalWrapper'

export const ModalContent = styled.div`
	display: grid;
	height: 100%;
	gap: 0.63em;
`

export const ModalButtons = styled.div`
	height: 100%;
	display: grid;
	grid-template-rows: repeat(6, 1fr);
	grid-gap: 0.7em;

	@media screen and (max-width: ${theme.point820}) {
		max-height: 48.57em;
	}

	@media screen and (max-width: ${theme.point720}) {
		grid-template-rows: auto;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 0.63em;
	}
`
ModalButtons.displayName = 'ModalButtons'

export const ModalButtonsItem = styled.button`
	font-size: 1rem;
	width: 100%;
	height: 100%;
	border-radius: 0.75em;
	background-color: ${colorTheme.processingTimeOrderModal.button.background};
	color: ${colorTheme.processingTimeOrderModal.button.text};
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	position: relative;
	padding: 0.75em;

	&.active, &:focus {
		background: ${colorTheme.processingTimeOrderModal.button.active.background};
		color: ${colorTheme.processingTimeOrderModal.button.active.text};
		padding-left: 2.18em;
		box-shadow: 0 4px 35px ${colorTheme.processingTimeOrderModal.button.active.shadow};

		&:after {
			display: block;
			content: url("data:image/svg+xml,%3Csvg viewBox='0 0 23 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.0041 0.552342L8.10471 13.3952L3.01103 7.76817C2.36673 7.05697 1.27001 7.00592 0.562336 7.65727C-0.141819 8.30861 -0.19199 9.41501 0.453192 10.1271L6.81259 17.1493C7.05112 17.4116 7.35831 17.5938 7.69454 17.673C7.82041 17.7012 7.94892 17.7179 8.08007 17.7179C8.56418 17.7214 9.02452 17.5207 9.35635 17.166L22.5337 2.94119C23.186 2.23615 23.1499 1.13063 22.451 0.471364C21.7556 -0.18614 20.658 -0.152693 20.0041 0.552342Z' fill='white'/%3E%3C/svg%3E%0A");
			position: absolute;
			top: calc(50% - 0.75em);
			left: 2.47em;
			width: 1.5em;
			height: 1.12em;
		}
	}

	&.disabled {
		background-color: ${colorTheme.processingTimeOrderModal.button.disabled.background};
		border-color: ${colorTheme.processingTimeOrderModal.button.disabled.border};

		&.active {
			box-shadow: none;
		}

		&:focus {
			box-shadow: none;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		height: 5.18em;

		&.active, &:focus {
			padding: 0;

			&:after {
				display: none;
			}
		}
	}
`
ModalButtonsItem.displayName = 'ModalButtonsItem'

export const ModalButtonsItemText = styled.div`
	font-size: 1.25em;
	font-family: ${theme.fontRobotoBold};

	&.regular {
		font-family: ${theme.fontRobotoRegular};
	}
`
ModalButtonsItemText.displayName = 'ModalButtonsItemText'

export const ModalButtonsItemDeny = styled.button`
	font-size: 1rem;
	width: 100%;
	border-radius: 0.75em;
	background-color: ${colorTheme.processingTimeOrderModal.denyButton.background};
	color: ${colorTheme.processingTimeOrderModal.denyButton.text};
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	position: relative;
	padding: 0.75em;
	gap: 0.3em;

	svg {
		width: 1.5em;
		height: 1.5em;
	}

	&.disabled {
		background-color: ${colorTheme.processingTimeOrderModal.denyButton.disabled.background};
		border-color: ${colorTheme.processingTimeOrderModal.denyButton.disabled.border};
	}

	@media screen and (max-width: ${theme.point720}) {
		height: 5.18em;

		&.active, &:focus {
			padding: 0;

			&:after {
				display: none;
			}
		}
	}
`
ModalButtonsItemDeny.displayName = 'ModalButtonsItemDeny'

export const OrderInfo = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 0.63em;

	@media screen and (max-width: ${theme.point720}) {
		margin-bottom: 0;
		grid-template-columns: auto;
	}
`

export const OrderInfoBlock = styled.div`
	border-radius: 0.75em;
	border: 1px solid ${colorTheme.processingTimeOrderModal.border};
	background: ${colorTheme.processingTimeOrderModal.background};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1em;
	min-height: 5.6em;
	min-width: 13.4em;

	&.lf-col-2 {
		grid-column: 1 / 3;
		gap: 1.56em;
	}

	@media screen and (max-width: ${theme.point820}) {
		&.lf-col-2 {
			flex-wrap: wrap;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		min-height: 7.5em;

		&.small {
			min-height: 6.87em;
		}

		&, &.lf-col-2 {
			grid-column: 1;
			gap: 0.63em;
		}
	}
`
OrderInfoBlock.displayName = 'OrderInfoBlock'

export const OrderInfoItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.63em;

	> svg {
		width: 1.87em;
		height: 1.87em;
		flex-shrink: 0;
		fill: ${colorTheme.processingTimeOrderModal.icon};
	}

	> p {
		font-size: 1.25em;
		color: ${colorTheme.processingTimeOrderModal.text};
		font-family: ${theme.fontRobotoRegular};

		&.lf-hidden {
			display: none;
		}
	}

	> .distance {
		background-color: ${colorTheme.processingTimeOrderModal.textGray};
		border-radius: 0.75em;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0.1em 0.4em;
	}

	&.small {
		gap: 0.44em;

		> svg {
			width: 1.56em;
			height: 1.56em;
			fill: ${colorTheme.processingTimeOrderModal.icon};
		}
	}

	&.left {
		> p {
			text-align: left;
		}
	}
`
OrderInfoItem.displayName = 'OrderInfoItem'

export const OrderMap = styled.div`
	height: 26.37em;
	width: 60em;
	display: flex;
	align-items: center;
	justify-content: center;

	& > img {
		display: none;
		width: 100%;
		max-height: 100%;
		object-fit: cover;
		border-radius: 12px;

		&.loaded {
			display: block;
		}
	}

	@media screen and (max-width: ${theme.point820}) {
		height: auto;
		width: 100%;
	}

	@media screen and (max-width: ${theme.point720}) {
		display: none;
	}
`
OrderMap.displayName = 'OrderMap'

export const OrderWrap = styled.div`
	height: 30em;
	width: 60em;
	display: flex;
	flex-direction: column;
	align-items: normal;
	justify-content: space-between;
	border: 1px solid ${colorTheme.processingTimeOrderModal.borderOrder};
	padding: 0.87em 0.63em;
	border-radius: 0.75em;

	&.with-tabs {
		height: 26.37em;
	}

	@media screen and (max-width: ${theme.point820}) {
		height: auto;
		width: 100%;

		&.with-tabs {
			height: auto;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		border: none;
		padding: 0;
		margin-top: 1.25em;
	}
`
OrderWrap.displayName = 'OrderWrap'

export const OrderTitle = styled(ModalHeader)`
	&.lf-hidden {
		display: none;
	}
`
OrderTitle.displayName = 'OrderTitle'

export const OrderUnpaidWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`
OrderUnpaidWrapper.displayName = 'OrderUnpaidWrapper'

export const OrderUnpaidContent = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5em;

	> svg {
		width: 1.31em;
		height: 1.31em;
		fill: ${colorTheme.processingTimeOrderModal.iconRed};
	}
`
OrderUnpaidContent.displayName = 'OrderUnpaidContent'

export const OrderUnpaidText = styled.div`
	color: ${colorTheme.processingTimeOrderModal.textRed};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.25em;
	font-weight: 500;

	&.small {
		font-size: 1em;
	}
`
OrderUnpaidText.displayName = 'OrderUnpaidText'
